import CONFIG from 'GlobalConfigFile';

const DEFAULT_SERVER = CONFIG.Server;
const URLEnv = CONFIG.URLEnv;

export function getUrls() {
  // 优化env.js
  const config = URLEnv[DEFAULT_SERVER];
  if (!config) {
    throw new Error(`Unknown server ${DEFAULT_SERVER}`);
  }
  // 根据当前的url获取对应地址
  const host =  window.location.origin;
  // console.log('host', host);
  
  config.BASE_HOST = host;
  config.BASE_URL = host + '/api/';
  config.socketUrl = host + '/eap_v2?id=';
  config.externalBaseUrl = host + '/api/s';
  return config;
}
